export class RouterConst {
  static LOGIN = 'login';
  static MAIN = 'main';
  static ADD_UPDATE = 'addUpdate';
  static REDIRECT_CHANGES = 'redirectStrategies';
  static MESSAGING_STRATEGIES = 'messagingStrategies';
  static DYNAMIC_IMAGES = 'dynamicImages';
  static IMAGE_UPLOADER = 'imageUploader';
  static BACKGROUND_UPLOADER = 'backgroundUploader'
  static FONTS_UPLOADER = 'fontsUploader'
  static TERMS_BUILDER = 'termsBuilder'
  static DESIGNER = 'shared';
  static DASHBOARD = 'key-user-metrics';
  static CHARTS = 'charts';
  static LOCATION_SETUP = 'locationSetup';
  static LOCATION_GROUPS = 'locationGroups';
  static LOCALES = 'locales';
  static ANALYTICS_USERS = 'analyticsUsers';
  static ANALYTICS_GROUPS = 'securityGroups';
  static LOCATION_REGIONS = 'regions';
  static ANALYTICS_EMAIL_ACCOUNTS = 'analyticsEmailAccounts';
  static ANALYTICS_SMS_ACCOUNTS = 'analyticsSmsAccounts';
  static ANALYTICS_PAYPAL_ACCOUNTS = 'analyticsPaypalAccounts';
  static ANALYTICS_GOOGLE_ACCOUNTS = 'analyticsGoogleAccounts';
  static ANALYTICS_TWITTER_ACCOUNTS = 'analyticsTwitterAccounts';
  static ANALYTICS_FACEBOOK_ACCOUNTS = 'analyticsFacebookAccounts';
  static ANALYTICS_MAILCHIMP_ACC = 'analyticsMailchimpAccounts';
  static ANALYTICS_VOUCHERS = 'analyticsVouchers';
  static ANALYTICS_PAYPAL_OPTIONS = 'analyticsPaypalOptions';
  static ANALYTICS_WIRED_MESSENGER_ACC = 'analyticsWiredMessenger';
  static SESSIONS_ACTIVE_SESSIONS = 'sessionsActiveSessions';
  static SESSIONS_SESSION_STAT = 'sessionsSessionStat';
  static COUNTRIES = 'countries';
  static CP_CODES = 'cp-codes';
  static CHANGE_LOG = 'changeLog';
  static ADMIN_CLIENTS = 'adminClients';
  static SESSION_SUMMARY = 'sessionSummary';
  static LOGIN_HISTORY = 'loginHistory';
  static USERS = 'users';
  static DATA = 'data';
  static LOGIN_METHOD = 'loginMethod';
  static SESSIONS = 'sessions';
  static NOT_LOGGED_IN_USERS = 'notLoggedInUsers';
  static FORGET_USER = 'forgetUser';
  static SESSION_DETAIL_REPORT = 'sessionDetailReport';
  static SMS_ACCOUNTING = 'smsAccounting';
  static OPT_IN_USERS = 'optInUsers';
  static SENT_MESSAGES = 'sentMessages';
  static PRIVACY = 'privacy';
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/globals/RoutersConst.ts